import React, { useEffect, useState } from 'react';
import { Box, Alert, Button } from '@mui/material';
import axiosInstance from '../axiosConfig';

const UserRolesManagement = () => {
  const [users, setUsers] = useState([]);
  const [modifiedUsers, setModifiedUsers] = useState([]);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
      if (alert && alert.severity !== "info") {
        const timer = setTimeout(() => {
          setAlert(null);
        }, 3000); // 3 Sekunden Timeout
    
        return () => clearTimeout(timer); // Cleanup-Funktion für den Timer
      }
    }, [alert]);

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.get('/admin/users', {
        headers: {
          Authorization: `${token}`,
        },
      });
      setUsers(response.data);
    };
    fetchUsers();
  }, []);

  const handleRoleChange = (index, role) => {
    const updatedUsers = [...users];
    updatedUsers[index].role = role;
    setUsers(updatedUsers);

    if (!modifiedUsers.find((user) => user._id === updatedUsers[index]._id)) {
      setModifiedUsers([...modifiedUsers, updatedUsers[index]]);
    }
  };

  const handleSubmitChanges = async () => {
    const token = localStorage.getItem('authToken');
    try {
      const response = await axiosInstance.put('/admin/users/update', modifiedUsers, {
        headers: {
          Authorization: `${token}`,
        },
      });
  
      // Wenn die Antwort erfolgreich ist (Statuscode 2xx), Erfolgsmeldung anzeigen
      if (response.status >= 200 && response.status < 300) {
        setAlert({
          severity: "success",
          message: "Änderungen erfolgreich übernommen."
        });
      }
    } catch (error) {
      // Bei einem Fehler die Fehlermeldung anzeigen
      setAlert({
        severity: "error",
        message: "Fehler beim Übernehmen der Änderungen. Bitte versuchen Sie es erneut."
      });
    }
  };

  return (
    <Box sx={{ ml: '1rem', mr: '1rem'}}>
      {/* Erfolgsnachricht */}
      {alert && (
        <Box sx={{ marginTop: '1rem'}}>
          <Alert severity={alert.severity}>
            {alert.message}
          </Alert>
        </Box>
      )}

      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>E-Mail</th>
            <th>Rolle</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user._id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>
                <select
                  value={user.role}
                  onChange={(e) => handleRoleChange(index, e.target.value)}
                >
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Button variant="contained" size="small" color="primary" onClick={handleSubmitChanges} sx={{ mb: 2, bgcolor: 'primary.light', '&:hover': { color: '#fff' } }} type="button">
        Änderungen übernehmen
      </Button>
    </Box>
  );
};

export default UserRolesManagement;
